import { NavLink } from "react-router-dom";
import "./Bbps.css";
let BillpaymentNav = (props: any) => {
    const active = props.active;
    return (
        <div className="paymentNav">
            <NavLink
                className={
                    active == "billpay" ? "billNavactive" : "billNavinactive"
                }
                to="/dashboard/bbps">
                Pay Bills
            </NavLink>
            <NavLink
                className={
                    active == "quickpay" ? "billNavactive" : "billNavinactive"
                }
                to="/dashboard/bbps/quick-pay">
                Quick Pay
            </NavLink>
            <NavLink
                className={
                    active == "complaints" ? "billNavactive" : "billNavinactive"
                }
                to="/dashboard/bbps/complaints">
                Complaints
            </NavLink>
            <NavLink
                className={
                    active == "transaction"
                        ? "billNavactive"
                        : "billNavinactive"
                }
                to="/dashboard/bbps/transaction">
                Bill Payment Transactions
            </NavLink>
        </div>
    );
};

export default BillpaymentNav;
